import { __rest } from "tslib";
import clsx from 'clsx';
import React, { useCallback } from 'react';
import FormContent from './FormContent';
export default function useRenderForm(_a) {
    var { refForErrorAlert } = _a, formProps = __rest(_a, ["refForErrorAlert"]);
    return useCallback(({ handleSubmit }) => {
        return (React.createElement("form", { className: clsx('kal-form', formProps.className), onSubmit: handleSubmit, id: formProps.id },
            React.createElement(FormContent, Object.assign({}, formProps, { ref: refForErrorAlert }))));
    }, [formProps, refForErrorAlert]);
}
//# sourceMappingURL=useRenderForm.js.map